import { useLocation, useRoutes } from "react-router-dom";
import { routes, modalRoutes } from "./router";

// A detail location carries the location it was opened over in
// state.backgroundLocation. That location may itself be a detail location, so
// walking it back out yields the full stack: [page, ...modals], outermost first.
function unwrapChain(location) {
  const chain = [];
  for (let cur = location; cur; cur = cur.state?.backgroundLocation) {
    chain.unshift(cur);
  }
  return chain;
}

function PageLayer({ location }) {
  return useRoutes(routes, location);
}

function ModalLayer({ location }) {
  return useRoutes(modalRoutes, location);
}

// The page location beneath any open modal(s) — what ScrollToTop and the
// drawer's dialog-clearing effect care about, since neither should fire when a
// modal opens or closes over the page they're already on.
export function usePageLocation() {
  return unwrapChain(useLocation())[0];
}

export default function AppRoutes() {
  const [page, ...modals] = unwrapChain(useLocation());
  return (
    <>
      <PageLayer location={page} />
      {/*
        Rendered flat, not recursively (each layer rendering its own background
        as a child): recursion would change the tree's depth as layers open and
        close, and React reconciles by position, so closing the top modal would
        remount everything beneath it — losing the collection grid's scroll
        position, for instance. Keyed by depth rather than location.key because
        the chain is a stack (push/pop only at the end) and a `replace`
        navigation — e.g. switching TV season — mints a new key, which would
        remount the modal on every switch if that were the key.
      */}
      {modals.map((location, depth) => (
        <ModalLayer key={depth} location={location} />
      ))}
    </>
  );
}
